





















































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
import { Getter } from "vuex-class";
// components
import vSelect from "vue-select";
import FolderTree from "@/components/common/folders/FolderTree.vue";
import ChannelInfoModal from "@/components/channels/modals/ChannelInfoModal.vue";
import ChannelDeleteModal from "@/components/channels/modals/ChannelDeleteModal.vue";
import ChannelCopyModal from "@/components/channels/modals/ChannelCopyModal.vue";
import ChannelPreviewModal from "@/components/channels/modals/ChannelPreviewModal.vue";
import CreatePostContextMenu from "@/components/channels/CreatePostContextMenu.vue";
import ChannelAddPostModal from "@/components/channels/modals/ChannelAddPostModal.vue";
import ChannelsTileView from "@/components/channels/ChannelsTileView.vue";
import ChannelAddHtmlPostTemplateModal from "@/components/channels/modals/ChannelAddHtmlPostTemplateModal.vue";
import ChannelAddCustomPostTemplateModal from "@/components/channels/modals/ChannelAddCustomPostTemplateModal.vue";

// service methods
import { getFilteredChannels, getChannelResolutions } from "@/services/channels/channelsService";
import { getChannelFilterSolutions } from "@/services/solutions/solutionService";
import { getAllContentTemplateSizes } from "@/services/contentTemplates/contentTemplateService";
import { getSetting, setSetting } from "@/services/autoSettings/autoSettingsService";

// types
import { Channel, ChannelsFilterDtoIn } from "@/services/channels/types";
import { Folder, FolderEntites } from "@/services/folders/types";
import { Option } from "@/services/common/types";
import { channelsFields } from "@/components/channels/fields/channelsFields";
import { HavePermition, PermitionEnum } from "@/components/security/Permitions";
import { FavoriteDto, FavoriteEntityType } from "@/services/favorites/types";
import { setFavorite } from "@/services/favorites/favoriteService";
import { GetLocalizedItemTypes } from "@/components/posts/PostTypeRegister";

    @Component({
        components: {
            vSelect,
            FolderTree,
            ChannelInfoModal,
            ChannelDeleteModal,
            ChannelCopyModal,
            ChannelPreviewModal,
            CreatePostContextMenu,
            ChannelAddPostModal,
            ChannelsTileView,
            ChannelAddHtmlPostTemplateModal,
            ChannelAddCustomPostTemplateModal
        }
    })
export default class Channels extends Vue {
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;
    // local state
    channels = [] as Array<Channel>;
    fields = [...channelsFields];
    isBusy = false;
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;
    sortBy = "name";
    sortDesc = false;
    // folders
    folderEntity = FolderEntites.Channels;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;
    folderTreeAutoSettingKey = "channels-show-folder-tree";

    // filter
    selectedSolution = null as Option | any;
    filterResolution = "" as string;
    filterPostType = "";
    // filter options
    solutions = [] as Array<Option>;
    searchText = "" as string;
    resolutions = [] as Array<String>;
    // posts
    selectedChannelId = "" as string;
    selectedItemTypes = [] as string[];
    displayView = "List";
    searchTimer = 0;

    // lifecycle hooks
    public created(): void {
        this.initFolderState();
        this.fetchData();
        this.$nextTick(() => {
            this.sortBy = "name";
            this.sortDesc = false;
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // methods & actions
    initFolderState() {
        this.showFolderTree = getSetting(this.folderTreeAutoSettingKey);
        if (typeof this.showFolderTree === "undefined") {
            // default status for folder tree is open for admin, closed for editors
            // if the current user has the permission UpdateChannel that we consider that current user is Admin!
            this.showFolderTree = this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.permitionEnum.UpdateChannel]);
        }
    }

    setChannelFolderId(data: { entityId: string, folderId: string }) {
        this.channels.forEach((channel) => {
            if (channel.id === data.entityId) channel.folderId = data.folderId;
        });
        this.loadChannels();
    }

    selectFolder(folder: Folder) {
        this.selectedFolderNode = folder;
        this.loadChannels();
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
            setSetting(this.folderTreeAutoSettingKey, this.showFolderTree);
            this.loadChannels();
        }
    }

    deleteChannel(data: { channelId: string, name: string }) {
        (this.$refs.channelDeleteModal as any).open(data.channelId, data.name);
    }

    copyChannel(channelId: string) {
        (this.$refs.channelCopyModal as any).open(channelId);
    }

    channelInfo(channelId: string) {
        (this.$refs.channelInfoModal as any).open(channelId);
    }

    previewChannel(channelId: string, name: string) {
        (this.$refs.channelPreviewModal as any).open(channelId, name);
    }

    updateChannelRoute(channelId: string) {
        if (this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.permitionEnum.UpdateChannel])) {
            return {
                name: "updatechannel",
                params: { channelId: channelId }
            };
        } else {
            return {
                name: "editorupdatechannel",
                params: { channelId: channelId }
            };
        }
    }

    fetchData() {
        this.loadChannels();
        if (this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.permitionEnum.ViewSolutionsUI])) {
            getChannelFilterSolutions().then(response => {
                this.solutions = response.map(x => ({
                    id: x.id,
                    text: x.name
                }));

                if (!this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.permitionEnum.UpdateChannel]) && this.fields.length === 3) {
                    this.fields.pop();
                }
            });
        }
        getChannelResolutions().then(response => {
            this.resolutions = response;
        });
    }

    loadChannels() {
        this.isBusy = true;
        this.channels = [] as Array<Channel>;
        getFilteredChannels({
            solutionId: this.selectedSolution ? this.selectedSolution.id : "",
            resolution: this.filterResolution ? this.filterResolution : "",
            postType: this.filterPostType ? this.filterPostType : "",
            folderId: this.selectedFolderNode ? this.selectedFolderNode.id : "",
            search: this.searchText,
            flatList: !this.showFolderTree
        } as ChannelsFilterDtoIn).then(response => {
            this.channels = response;
            this.isBusy = false;
        });
    }

    clearFilter() {
        this.selectedSolution = null;
        this.filterResolution = "";
        this.filterPostType = "";
        this.setFolderTreeStateAndLoadChannels();
    }

    clearSearchFilter() {
        this.searchText = "";
        this.setFolderTreeStateAndLoadChannels();
    }

    setFolderTreeStateAndLoadChannels() {
        if (!this.filterActive) {
            this.initFolderState(); // Ensure folder tree state is set correctly when search & filter are not active
        }
        this.loadChannels();
    }

    toggleFavorite(channel: Channel) {
        const data = {
            entity: FavoriteEntityType.Channel,
            entityId: channel.id,
            state: !channel.favorite
        } as FavoriteDto;

        setFavorite(data).then(response => {
            channel.favorite = !channel.favorite;
        });
    }

    async onHtmlPostModal(channelId: string, postType = "html") {
        // This check will be replaced with ContentTemplate ACL list
        const sizes = await getAllContentTemplateSizes();

        if (postType.toLowerCase() === "fixedhtml") {
            (this.$refs.htmlItemTemplatesModal as any).open(true, sizes, postType);
        } else {
            if (sizes.filter(x => x.type.toLowerCase() !== "fixedhtml").length > 0) {
                (this.$refs.htmlItemTemplatesModal as any).open(true, sizes, postType);
                return;
            }
            await this.$router.push({
                name: "createPost",
                params: {
                    channelId: this.selectedChannelId,
                    postType: "html"
                }
            });
        }
    }

    filterText() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.loadChannels(), 1000);
    }

    // computed and watchers

    get filterActive(): boolean {
        return (
            (this.selectedSolution && Object.keys(this.selectedSolution.id).length > 0) ||
            this.searchText !== "" ||
            (!!this.filterResolution && this.filterResolution !== "") ||
            (!!this.filterPostType && this.filterPostType !== ""));
    }

    get addChannel() {
        return {
            name: "newchannel",
            params: { folderId: this.selectedFolderNode.id }
        };
    }

    get postTypes() {
        return GetLocalizedItemTypes();
    }

    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        if (value) {
            this.showFolderTree = false;
        } else {
            this.initFolderState();
        }
    }

    // events
    onOpenItemsModal(data: any) {
        this.selectedChannelId = data.channelId;
        this.selectedItemTypes = data.selectedItemTypes;
        (this.$refs.channelAddItemModal as any).open();
    }

    async onOpenContentModal(channelId: string, postType: string) {
        const sizes = await getAllContentTemplateSizes();
        this.selectedChannelId = channelId;

        if (postType.toLowerCase() === "fixedhtml") {
            (this.$refs.htmlItemTemplatesModal as any).open(true, sizes, postType);
        }

        if (postType.toLowerCase() === "html") {
            if (sizes.filter(x => x.type.toLowerCase() !== "fixedhtml").length > 0) {
                (this.$refs.customItemTemplatesModal as any).open(true, sizes, postType);
            } else {
                await this.$router.push({
                    name: "createPost",
                    params: {
                        channelId: this.selectedChannelId,
                        postType: "html"
                    }
                });
            }
        }
    }

    // drag events
    drag(event: any) {
        event.dataTransfer.setDragImage(this.$refs["element_" + event.target.getAttribute("entityId")] as any, -10, 0);
        event.dataTransfer.setData(
            "type",
            event.target.getAttribute("type")
        );
        event.dataTransfer.setData(
            "folderEntity",
            event.target.getAttribute("folderEntity")
        );
        event.dataTransfer.setData(
            "entityId",
            event.target.getAttribute("entityId")
        );
    }
}
